import { render, staticRenderFns } from "./DocumentUploadLedger.vue?vue&type=template&id=6f80dc52&"
import script from "./DocumentUploadLedger.vue?vue&type=script&lang=js&"
export * from "./DocumentUploadLedger.vue?vue&type=script&lang=js&"
import style0 from "./DocumentUploadLedger.vue?vue&type=style&index=0&id=6f80dc52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports